import { c as _c } from "react/compiler-runtime";
import { DataFileInterface, FileActionMenuDeleteItem, FileActionMenuDetailsItem, FileActionMenuDownloadItem, FileActionMenuRenameItem, FileDetails, FilePreview, FileSearch, FileSourceEnum, FileSourceEnumLocoKeys, FileTypeEnum, FileTypeEnumLocoKeys, FileUploaderModal, PaginationOrderEnum, formatBytes, useDataFiles, useFileActions, useFileDetails, useTranslation } from '@systemeio/file-manager';
import { AddIcon } from '@systemeio/ui/icons';
import { FormInput, PrimaryButton, useWindowSize } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { FileManagerLoco } from 'modules/file-manager/file-manager-loco';
import { useEffect, useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import ListingLayout from 'shared/components/listing-layout';
import { SortDirectionEnum } from 'shared/components/table/enums';
import { Table } from 'shared/components/table/table';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useModal } from 'shared/hooks/use-modal';
import useUser from 'shared/hooks/use-user';
import { useFilterSortPagination } from 'shared/route-query/hooks/use-filter-sort-pagination';
import { useSorter } from 'shared/route-query/hooks/use-sorter';
import { OrderEnum } from 'shared/types/pagination-interface';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { twMerge } from 'tailwind-merge';
const defaultFilters = {
  name: '',
  source: [],
  type: []
};
type FilterType = {
  name: string;
  source: FileSourceEnum[];
  type: FileTypeEnum[];
};
const defaultSort: useSorter.SortInterface<keyof DataFileInterface> = {
  sortColumn: 'createdAt',
  sortDirection: SortDirectionEnum.Desc
};
export default function Files() {
  const $ = _c(212);
  const {
    t: tFileManager
  } = useTranslation();
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const {
    width
  } = useWindowSize();
  const isMobile = width < 1024;
  const {
    filterer,
    sorter,
    paginator
  } = useFilterSortPagination(defaultFilters, undefined, defaultSort);
  const [innerFilter, setInnerFilter] = useState(defaultFilters);
  let t0;
  if ($[0] !== paginator.pagination.order) {
    t0 = () => {
      if (paginator.pagination.order === OrderEnum.prev) {
        return PaginationOrderEnum.Prev;
      } else {
        return PaginationOrderEnum.Next;
      }
    };
    $[0] = paginator.pagination.order;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getOrder = t0;
  const t1 = paginator.pagination.startFromId ? encodeURIComponent(String(paginator.pagination.startFromId)) : undefined;
  let t2;
  if ($[2] !== getOrder) {
    t2 = getOrder();
    $[2] = getOrder;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== filterer.filter.name || $[5] !== filterer.filter.source || $[6] !== filterer.filter.type) {
    t3 = {
      name: filterer.filter.name,
      source: filterer.filter.source,
      type: filterer.filter.type
    };
    $[4] = filterer.filter.name;
    $[5] = filterer.filter.source;
    $[6] = filterer.filter.type;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = sorter.sort.sortDirection ?? undefined;
  let t5;
  if ($[8] !== paginator.limit || $[9] !== sorter.sort.sortColumn || $[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = {
      startFrom: t1,
      order: t2,
      limit: paginator.limit,
      filter: t3,
      sortColumn: sorter.sort.sortColumn,
      sortDirection: t4
    };
    $[8] = paginator.limit;
    $[9] = sorter.sort.sortColumn;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = !!user;
  let t7;
  if ($[15] !== t6) {
    t7 = {
      enabled: t6
    };
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const {
    data,
    resetAndRefetch,
    renameItemFromData,
    deleteItemFromData,
    isFetching,
    isRefetching
  } = useDataFiles(t5, t7);
  const {
    deleteFile,
    downloadFile,
    renameFile
  } = useFileActions();
  const {
    data: detailsPreviewData,
    opened: detailsPreviewOpened,
    open: openDetailsPreview,
    close: closeDetailsPreview
  } = useModal();
  const t8 = detailsPreviewData?.id;
  let t9;
  if ($[17] !== t8) {
    t9 = {
      id: t8
    };
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const {
    data: detailsData,
    isFetching: isFetchingDetailsData
  } = useFileDetails(t9);
  let t10;
  let t11;
  if ($[19] !== filterer.filter) {
    t10 = () => {
      setInnerFilter(filterer.filter);
    };
    t11 = [filterer.filter];
    $[19] = filterer.filter;
    $[20] = t10;
    $[21] = t11;
  } else {
    t10 = $[20];
    t11 = $[21];
  }
  useEffect(t10, t11);
  let t12;
  if ($[22] !== filterer || $[23] !== innerFilter || $[24] !== paginator) {
    t12 = () => {
      filterer.setFilter(innerFilter);
      paginator.setFirstPage();
    };
    $[22] = filterer;
    $[23] = innerFilter;
    $[24] = paginator;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const handleSearch = t12;
  const [uploadingFilesModalOpened, setUploadingModalOpened] = useState(false);
  const [renameFileError, setRenameFileError] = useState();
  const [newFileName, setNewFileName] = useState("");
  const renameFileModal = useModal();
  let t13;
  if ($[26] !== renameFileModal) {
    t13 = file => {
      setNewFileName(file.name);
      renameFileModal.open(file);
    };
    $[26] = renameFileModal;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const handleRenameModalOpen = t13;
  let t14;
  if ($[28] !== newFileName || $[29] !== renameFile || $[30] !== renameFileModal.data || $[31] !== renameItemFromData) {
    t14 = async () => {
      const fileToRename = renameFileModal.data;
      if (!fileToRename) {
        return;
      }
      ;
      try {
        setRenameFileError(undefined);
        await renameFile({
          id: fileToRename.id,
          name: newFileName
        });
        renameItemFromData({
          id: fileToRename.id,
          name: newFileName
        });
      } catch (t15) {
        const e = t15;
        if (e instanceof BadRequest) {
          setRenameFileError(e.errors.fields.name?.join(" "));
        }
        throw e;
      }
    };
    $[28] = newFileName;
    $[29] = renameFile;
    $[30] = renameFileModal.data;
    $[31] = renameItemFromData;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  const handleRenameFile = t14;
  let t15;
  if ($[33] !== downloadFile) {
    t15 = async file_0 => {
      try {
        await downloadFile({
          id: file_0.id
        });
      } catch {}
    };
    $[33] = downloadFile;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  const handleDownload = t15;
  let t16;
  if ($[35] !== deleteFile || $[36] !== deleteItemFromData) {
    t16 = async file_1 => {
      await deleteFile({
        id: file_1.id
      });
      deleteItemFromData(file_1.id);
    };
    $[35] = deleteFile;
    $[36] = deleteItemFromData;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  const handleDelete = t16;
  let t17;
  if ($[38] !== t) {
    t17 = t("dashboard.file_manager.files");
    $[38] = t;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  let t19;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = () => setUploadingModalOpened(true);
    t19 = <AddIcon />;
    $[40] = t18;
    $[41] = t19;
  } else {
    t18 = $[40];
    t19 = $[41];
  }
  let t20;
  if ($[42] !== tFileManager) {
    t20 = tFileManager("file_manager.file_upload.upload_files");
    $[42] = tFileManager;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t20) {
    t21 = <PrimaryButton onClick={t18}>{t19}{t20}</PrimaryButton>;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  const t22 = !!detailsPreviewOpened ? "w-3/4" : "w-full";
  const t23 = isMobile && !!detailsPreviewOpened ? "hidden" : "auto";
  let t24;
  if ($[46] !== t22 || $[47] !== t23) {
    t24 = twMerge(t22, t23);
    $[46] = t22;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  const t25 = isRefetching || isFetching;
  let t26;
  if ($[49] !== handleSearch || $[50] !== innerFilter || $[51] !== t25) {
    t26 = <FileSearch isFetching={t25} values={innerFilter} onChange={setInnerFilter} onSubmit={handleSearch} />;
    $[49] = handleSearch;
    $[50] = innerFilter;
    $[51] = t25;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== sorter.sort.sortColumn) {
    t27 = row => JSON.stringify({
      id: row.id,
      field: row[(sorter.sort.sortColumn ?? defaultSort.sortColumn) as keyof DataFileInterface]
    });
    $[53] = sorter.sort.sortColumn;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== tFileManager) {
    t28 = tFileManager("file_manager.file");
    $[55] = tFileManager;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] !== detailsPreviewData?.id) {
    t29 = row_0 => row_0.id === detailsPreviewData?.id ? "border-brand-primary" : "";
    $[57] = detailsPreviewData?.id;
    $[58] = t29;
  } else {
    t29 = $[58];
  }
  let t30;
  if ($[59] !== closeDetailsPreview || $[60] !== detailsPreviewData?.id || $[61] !== openDetailsPreview) {
    t30 = instance => {
      if (instance.id !== detailsPreviewData?.id) {
        openDetailsPreview(instance);
      } else {
        closeDetailsPreview();
      }
    };
    $[59] = closeDetailsPreview;
    $[60] = detailsPreviewData?.id;
    $[61] = openDetailsPreview;
    $[62] = t30;
  } else {
    t30 = $[62];
  }
  let t31;
  if ($[63] !== tFileManager) {
    t31 = tFileManager("file_manager.name");
    $[63] = tFileManager;
    $[64] = t31;
  } else {
    t31 = $[64];
  }
  let t32;
  if ($[65] !== sorter) {
    t32 = sorter.getSortDirection("name");
    $[65] = sorter;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  let t33;
  if ($[67] !== sorter) {
    t33 = () => sorter.setNextSortDirection("name");
    $[67] = sorter;
    $[68] = t33;
  } else {
    t33 = $[68];
  }
  let t34;
  if ($[69] !== t32 || $[70] !== t33) {
    t34 = {
      sortOrder: t32,
      onSortOrderChange: t33
    };
    $[69] = t32;
    $[70] = t33;
    $[71] = t34;
  } else {
    t34 = $[71];
  }
  let t35;
  if ($[72] !== t31 || $[73] !== t34) {
    t35 = {
      key: "name",
      header: t31,
      widthPercent: 30,
      sort: t34,
      onRender: _temp
    };
    $[72] = t31;
    $[73] = t34;
    $[74] = t35;
  } else {
    t35 = $[74];
  }
  let t36;
  if ($[75] !== tFileManager) {
    t36 = tFileManager("file_manager.type");
    $[75] = tFileManager;
    $[76] = t36;
  } else {
    t36 = $[76];
  }
  let t37;
  if ($[77] !== tFileManager) {
    t37 = instance_1 => <div>{tFileManager(FileTypeEnumLocoKeys[instance_1.type])}</div>;
    $[77] = tFileManager;
    $[78] = t37;
  } else {
    t37 = $[78];
  }
  let t38;
  if ($[79] !== t36 || $[80] !== t37) {
    t38 = {
      key: "type",
      header: t36,
      widthPercent: 7,
      onRender: t37
    };
    $[79] = t36;
    $[80] = t37;
    $[81] = t38;
  } else {
    t38 = $[81];
  }
  let t39;
  if ($[82] !== tFileManager) {
    t39 = tFileManager("file_manager.size");
    $[82] = tFileManager;
    $[83] = t39;
  } else {
    t39 = $[83];
  }
  let t40;
  if ($[84] !== sorter) {
    t40 = sorter.getSortDirection("size");
    $[84] = sorter;
    $[85] = t40;
  } else {
    t40 = $[85];
  }
  let t41;
  if ($[86] !== sorter) {
    t41 = () => sorter.setNextSortDirection("size");
    $[86] = sorter;
    $[87] = t41;
  } else {
    t41 = $[87];
  }
  let t42;
  if ($[88] !== t40 || $[89] !== t41) {
    t42 = {
      sortOrder: t40,
      onSortOrderChange: t41
    };
    $[88] = t40;
    $[89] = t41;
    $[90] = t42;
  } else {
    t42 = $[90];
  }
  let t43;
  if ($[91] !== t39 || $[92] !== t42) {
    t43 = {
      key: "size",
      header: t39,
      widthPercent: 7,
      sort: t42,
      onRender: _temp2
    };
    $[91] = t39;
    $[92] = t42;
    $[93] = t43;
  } else {
    t43 = $[93];
  }
  let t44;
  if ($[94] !== t) {
    t44 = t("global.source");
    $[94] = t;
    $[95] = t44;
  } else {
    t44 = $[95];
  }
  let t45;
  if ($[96] !== tFileManager) {
    t45 = instance_3 => <div className="truncate" title={tFileManager(FileSourceEnumLocoKeys[instance_3.source])}>{tFileManager(FileSourceEnumLocoKeys[instance_3.source])}</div>;
    $[96] = tFileManager;
    $[97] = t45;
  } else {
    t45 = $[97];
  }
  let t46;
  if ($[98] !== t44 || $[99] !== t45) {
    t46 = {
      key: "source",
      header: t44,
      widthPercent: 10,
      onRender: t45
    };
    $[98] = t44;
    $[99] = t45;
    $[100] = t46;
  } else {
    t46 = $[100];
  }
  let t47;
  if ($[101] !== tFileManager) {
    t47 = tFileManager("file_manager.created_at");
    $[101] = tFileManager;
    $[102] = t47;
  } else {
    t47 = $[102];
  }
  let t48;
  if ($[103] !== sorter) {
    t48 = sorter.getSortDirection("createdAt");
    $[103] = sorter;
    $[104] = t48;
  } else {
    t48 = $[104];
  }
  let t49;
  if ($[105] !== sorter) {
    t49 = () => sorter.setNextSortDirection("createdAt");
    $[105] = sorter;
    $[106] = t49;
  } else {
    t49 = $[106];
  }
  let t50;
  if ($[107] !== t48 || $[108] !== t49) {
    t50 = {
      sortOrder: t48,
      onSortOrderChange: t49
    };
    $[107] = t48;
    $[108] = t49;
    $[109] = t50;
  } else {
    t50 = $[109];
  }
  let t51;
  if ($[110] !== user?.dateFormat || $[111] !== user?.timeFormat || $[112] !== user?.timezone) {
    t51 = t52 => {
      const {
        createdAt
      } = t52;
      const content = dateTimeFormat(createdAt, {
        timeFormat: user?.timeFormat,
        dateFormat: user?.dateFormat,
        timeZone: user?.timezone
      });
      return <div className="truncate" title={content}>{content}</div>;
    };
    $[110] = user?.dateFormat;
    $[111] = user?.timeFormat;
    $[112] = user?.timezone;
    $[113] = t51;
  } else {
    t51 = $[113];
  }
  let t52;
  if ($[114] !== t47 || $[115] !== t50 || $[116] !== t51) {
    t52 = {
      key: "createdAt",
      header: t47,
      widthPercent: 15,
      sort: t50,
      onRender: t51
    };
    $[114] = t47;
    $[115] = t50;
    $[116] = t51;
    $[117] = t52;
  } else {
    t52 = $[117];
  }
  let t53;
  if ($[118] !== t35 || $[119] !== t38 || $[120] !== t43 || $[121] !== t46 || $[122] !== t52) {
    t53 = [t35, t38, t43, t46, t52];
    $[118] = t35;
    $[119] = t38;
    $[120] = t43;
    $[121] = t46;
    $[122] = t52;
    $[123] = t53;
  } else {
    t53 = $[123];
  }
  let t54;
  if ($[124] !== openDetailsPreview) {
    t54 = {
      name: "details",
      CustomActionMenuItem: FileActionMenuDetailsItem,
      onActionClick: instance_4 => {
        openDetailsPreview(instance_4);
      }
    };
    $[124] = openDetailsPreview;
    $[125] = t54;
  } else {
    t54 = $[125];
  }
  let t55;
  if ($[126] !== handleDownload) {
    t55 = {
      name: "download",
      CustomActionMenuItem: FileActionMenuDownloadItem,
      onActionClick: handleDownload
    };
    $[126] = handleDownload;
    $[127] = t55;
  } else {
    t55 = $[127];
  }
  let t56;
  if ($[128] !== handleRenameModalOpen) {
    t56 = {
      name: "rename",
      CustomActionMenuItem: FileActionMenuRenameItem,
      onActionClick: handleRenameModalOpen
    };
    $[128] = handleRenameModalOpen;
    $[129] = t56;
  } else {
    t56 = $[129];
  }
  let t57;
  if ($[130] !== t54 || $[131] !== t55 || $[132] !== t56) {
    t57 = [t54, t55, t56];
    $[130] = t54;
    $[131] = t55;
    $[132] = t56;
    $[133] = t57;
  } else {
    t57 = $[133];
  }
  let t58;
  if ($[134] !== handleDelete) {
    t58 = {
      CustomActionMenuItem: FileActionMenuDeleteItem,
      showSuccessToast: true,
      onChange: handleDelete
    };
    $[134] = handleDelete;
    $[135] = t58;
  } else {
    t58 = $[135];
  }
  let t59;
  if ($[136] !== t57 || $[137] !== t58) {
    t59 = {
      custom: t57,
      remove: t58
    };
    $[136] = t57;
    $[137] = t58;
    $[138] = t59;
  } else {
    t59 = $[138];
  }
  let t60;
  if ($[139] !== paginator.limit || $[140] !== paginator.setLimit) {
    t60 = {
      limit: paginator.limit,
      setLimit: paginator.setLimit
    };
    $[139] = paginator.limit;
    $[140] = paginator.setLimit;
    $[141] = t60;
  } else {
    t60 = $[141];
  }
  let t61;
  if ($[142] !== data || $[143] !== paginator || $[144] !== t27 || $[145] !== t28 || $[146] !== t29 || $[147] !== t30 || $[148] !== t53 || $[149] !== t59 || $[150] !== t60) {
    t61 = <Table data={data} rowIdParser={t27} caption={t28} rowClassName={t29} onRowClick={t30} columns={t53} actions={t59} limiter={t60} paginator={paginator} />;
    $[142] = data;
    $[143] = paginator;
    $[144] = t27;
    $[145] = t28;
    $[146] = t29;
    $[147] = t30;
    $[148] = t53;
    $[149] = t59;
    $[150] = t60;
    $[151] = t61;
  } else {
    t61 = $[151];
  }
  let t62;
  if ($[152] !== t26 || $[153] !== t61) {
    t62 = <div className="mt-2 flex flex-col gap-5">{t26}{t61}</div>;
    $[152] = t26;
    $[153] = t61;
    $[154] = t62;
  } else {
    t62 = $[154];
  }
  let t63;
  if ($[155] !== t24 || $[156] !== t62) {
    t63 = <div className={t24}>{t62}</div>;
    $[155] = t24;
    $[156] = t62;
    $[157] = t63;
  } else {
    t63 = $[157];
  }
  let t64;
  if ($[158] !== closeDetailsPreview || $[159] !== detailsData?.name || $[160] !== detailsData?.path || $[161] !== detailsData?.size || $[162] !== detailsData?.type || $[163] !== detailsPreviewOpened || $[164] !== isFetchingDetailsData || $[165] !== isMobile) {
    t64 = detailsPreviewOpened && <FileDetails className={twMerge("sticky top-5 h-fit", isMobile ? "w-full" : "max-w-[calc(25%-28px)]")} fileType={detailsData?.type} src={detailsData?.path ?? undefined} alt={detailsData?.name} name={detailsData?.name} size={detailsData?.size} onClose={closeDetailsPreview} isFetching={isFetchingDetailsData} />;
    $[158] = closeDetailsPreview;
    $[159] = detailsData?.name;
    $[160] = detailsData?.path;
    $[161] = detailsData?.size;
    $[162] = detailsData?.type;
    $[163] = detailsPreviewOpened;
    $[164] = isFetchingDetailsData;
    $[165] = isMobile;
    $[166] = t64;
  } else {
    t64 = $[166];
  }
  let t65;
  if ($[167] !== t63 || $[168] !== t64) {
    t65 = <div className="flex gap-7">{t63}{t64}</div>;
    $[167] = t63;
    $[168] = t64;
    $[169] = t65;
  } else {
    t65 = $[169];
  }
  let t66;
  if ($[170] === Symbol.for("react.memo_cache_sentinel")) {
    t66 = () => setUploadingModalOpened(false);
    $[170] = t66;
  } else {
    t66 = $[170];
  }
  let t67;
  if ($[171] !== resetAndRefetch) {
    t67 = async () => {
      setUploadingModalOpened(false);
      await resetAndRefetch();
    };
    $[171] = resetAndRefetch;
    $[172] = t67;
  } else {
    t67 = $[172];
  }
  let t68;
  if ($[173] !== t67 || $[174] !== uploadingFilesModalOpened) {
    t68 = <FileUploaderModal source={FileSourceEnum.FileManager} opened={uploadingFilesModalOpened} onClose={t66} onUploadFinish={t67} />;
    $[173] = t67;
    $[174] = uploadingFilesModalOpened;
    $[175] = t68;
  } else {
    t68 = $[175];
  }
  let t69;
  if ($[176] !== tFileManager) {
    t69 = tFileManager("file_manager.file_selector.rename_file");
    $[176] = tFileManager;
    $[177] = t69;
  } else {
    t69 = $[177];
  }
  let t70;
  if ($[178] !== tFileManager) {
    t70 = tFileManager("file_manager.rename");
    $[178] = tFileManager;
    $[179] = t70;
  } else {
    t70 = $[179];
  }
  const t71 = renameFileModal.opened;
  const t72 = renameFileModal.close;
  let t73;
  if ($[180] === Symbol.for("react.memo_cache_sentinel")) {
    t73 = () => {
      setNewFileName("");
      setRenameFileError(undefined);
    };
    $[180] = t73;
  } else {
    t73 = $[180];
  }
  let t74;
  if ($[181] !== tFileManager) {
    t74 = tFileManager("file_manager.file_renamed_successfully");
    $[181] = tFileManager;
    $[182] = t74;
  } else {
    t74 = $[182];
  }
  let t75;
  if ($[183] !== tFileManager) {
    t75 = tFileManager("file_manager.file_selector.file_name");
    $[183] = tFileManager;
    $[184] = t75;
  } else {
    t75 = $[184];
  }
  let t76;
  if ($[185] !== tFileManager) {
    t76 = tFileManager("file_manager.file_selector.enter_new_file_name");
    $[185] = tFileManager;
    $[186] = t76;
  } else {
    t76 = $[186];
  }
  let t77;
  if ($[187] === Symbol.for("react.memo_cache_sentinel")) {
    t77 = e_0 => setNewFileName(e_0.target.value);
    $[187] = t77;
  } else {
    t77 = $[187];
  }
  let t78;
  if ($[188] !== newFileName || $[189] !== renameFileError || $[190] !== t75 || $[191] !== t76) {
    t78 = <FormInput autoFocus={true} label={t75} placeholder={t76} value={newFileName} onChange={t77} error={renameFileError} />;
    $[188] = newFileName;
    $[189] = renameFileError;
    $[190] = t75;
    $[191] = t76;
    $[192] = t78;
  } else {
    t78 = $[192];
  }
  let t79;
  if ($[193] !== handleRenameFile) {
    t79 = () => handleRenameFile();
    $[193] = handleRenameFile;
    $[194] = t79;
  } else {
    t79 = $[194];
  }
  let t80;
  if ($[195] !== renameFileModal.close || $[196] !== renameFileModal.opened || $[197] !== t69 || $[198] !== t70 || $[199] !== t74 || $[200] !== t78 || $[201] !== t79) {
    t80 = <ConfirmationModal title={t69} confirmButtonCaption={t70} opened={t71} onClose={t72} afterLeave={t73} toastCaption={t74} confirmationContent={t78} onConfirm={t79} />;
    $[195] = renameFileModal.close;
    $[196] = renameFileModal.opened;
    $[197] = t69;
    $[198] = t70;
    $[199] = t74;
    $[200] = t78;
    $[201] = t79;
    $[202] = t80;
  } else {
    t80 = $[202];
  }
  let t81;
  if ($[203] !== t65 || $[204] !== t68 || $[205] !== t80) {
    t81 = <>{t65}{t68}{t80}</>;
    $[203] = t65;
    $[204] = t68;
    $[205] = t80;
    $[206] = t81;
  } else {
    t81 = $[206];
  }
  let t82;
  if ($[207] !== data || $[208] !== t17 || $[209] !== t21 || $[210] !== t81) {
    t82 = <ListingLayout data={data} title={t17} type="compact" counter={false} customHeaderElement={t21}>{t81}</ListingLayout>;
    $[207] = data;
    $[208] = t17;
    $[209] = t21;
    $[210] = t81;
    $[211] = t82;
  } else {
    t82 = $[211];
  }
  return t82;
}
function _temp2(instance_2) {
  return <div>{formatBytes(instance_2.size)}</div>;
}
function _temp(instance_0) {
  return <div className="flex items-center gap-2" title={instance_0.name}><FilePreview fileType={instance_0.type} src={instance_0.thumbnail ?? ""} alt={instance_0.name} className="h-[46px] min-w-[60px] max-w-[60px]" isThumbnail={true} /><div className="truncate">{instance_0.name}</div></div>;
}
export const getServerSideProps = getBaseServerSideProps(FileManagerLoco);